import { render, staticRenderFns } from "./ScreenCondition.vue?vue&type=template&id=2fa95be8&scoped=true&"
import script from "./ScreenCondition.vue?vue&type=script&lang=js&"
export * from "./ScreenCondition.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCondition.vue?vue&type=style&index=0&id=2fa95be8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa95be8",
  null
  
)

export default component.exports